interface ExclamationMarkIconProps {
  className?: string;
}

export const ExclamationMarkIcon = ({ className = "" }: ExclamationMarkIconProps) => {
  return (
    <svg className={`w-5 h-5 ${className}`} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.34526 2.44C9.73569 1.77333 10.2643 1.77333 10.6547 2.44L19.1962 16.44C19.5774 17.1067 19.1151 17.94 18.3509 17.94H1.64907C0.884876 17.94 0.422621 17.1067 0.803808 16.44L9.34526 2.44Z"
        className="fill-red"
      />
      <text
        x="10"
        y="12"
        className="fill-white font-inter text-[12px] font-bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        !
      </text>
    </svg>
  );
};
